export { default } from './ValidationTable';
